import React, { Component } from "react";
import styled from "styled-components";
import colors from "../../../../utils/colors";
import { rem } from "polished";
import PropTypes from "prop-types";

const Wrapper = styled.a`
  transition: background 0.125s ease-out;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap:8px;
  width: ${rem("32px")};
  height: ${rem("30px")};
  background: ${colors.TRANSPARENT};
  z-index: 101;
  .hm-line {
    transition: opacity 0.125s ease-in, transform 0.25s ease-out, background 0.125s ease-out;
    transform: rotate(0deg);
    width: 100%;
    height: 2px;
    background: ${colors.WHITE};

    &.top {

    }
    &.middle {
      opacity: 1;
    }
    &.bottom {

    }
  }

  &.open {
    .hm-line {
      &.top {
        transform: translate(0px, 20.2px) rotate(-45deg) scalex(1);
      }
      &.middle {
        opacity: 0;
      }
      &.bottom {
        transform: translate(0px, 0px) rotate(45deg) scalex(1);
      }
    }
  }
`;

  class HamburgerToggler extends Component {
  getClass = c => {
    if (this.props.open) {
      c += " open";
    }
    return c;
  };

  render() {
    const isOpen=this.props.open;
    return (
      <Wrapper open={isOpen} className={this.getClass("hamburger-toggler")} onClick={this.props.onToggle}>
        <span className="hm-line top" />
        <span className="hm-line middle" />
        <span className="hm-line bottom" />
      </Wrapper>
    );
  }
}

HamburgerToggler.propTypes = {
  open: PropTypes.bool,
  onToggle: PropTypes.func
};

HamburgerToggler.defaultProps = {
  open: false,
  onToggle: null
};

export default HamburgerToggler;



// WEBPACK FOOTER //
// ./src/modules/common/components/app/HamburgerToggler.js